/* eslint-disable camelcase */

import Vuetify from '../../plugins/vuetify'
import { CriticalDatasetLabels } from '../../enum'

const _t = (text) => Vuetify.framework.lang.t(text)

export class ActionsEntry {
  constructor ({ headphones = false, left_hand_hides_belt = false, right_hand_hides_belt = false } = {}) {
    this.headphones = headphones // boolean
    this.leftHandHidesBelt = left_hand_hides_belt // boolean
    this.rightHandHidesBelt = right_hand_hides_belt // boolean
  }

  filters () {
    const result = {}
    for (const field of Object.keys(this)) {
      result[field] = false
    }
    return result
  }

  backendModel () {
    return {
      headphones: this.headphones,
      left_hand_hides_belt: this.leftHandHidesBelt,
      right_hand_hides_belt: this.rightHandHidesBelt
    }
  }

  get textRepresentation () {
    const result = []

    if (this.headphones) {
      result.push(_t(`$vuetify.criticalDataset.${CriticalDatasetLabels.ACTIONS}.headphonesDataset`))
    }

    if (this.leftHandHidesBelt) {
      result.push(_t(`$vuetify.criticalDataset.${CriticalDatasetLabels.ACTIONS}.leftHandHidesBeltDataset`))
    }

    if (this.rightHandHidesBelt) {
      result.push(_t(`$vuetify.criticalDataset.${CriticalDatasetLabels.ACTIONS}.rightHandHidesBeltDataset`))
    }

    return result.map(item => ({
      item,
      color: 'green',
      type: CriticalDatasetLabels.ACTIONS
    }))
  }
}
